import {
  initialState,
  Actions,
  State,
  GET_PLANS,
  UPDATE_GET_PLANS,
  GET_PLANS_SUCCESS,
  GET_PLANS_ERROR,
  RESET_GET_PLANS,
} from "../../types/plan/get-all";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_PLANS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_PLANS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_PLANS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case UPDATE_GET_PLANS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      };
    case RESET_GET_PLANS:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
